//#region Core
export enum NotificationType {
  General = 1,
}
export interface INotificationDto {
  id: number;
  type: NotificationType;
  title: string;
  message: string;
  details: string;
  createdAt: string | Date;
  seen: boolean;

  // local
  formattedDate?: string | null;
  timeAgo?: string | null;
}
export interface INotificationFiltersDto {
  page: number;
  pageSize: number;
}
export interface INotificationsResultDto {
  notifications: INotificationDto[];
  total: number;
  newNotificationsTotal: number;
}
export interface IDropDownDto {
  id: number | null;
  name: string;
}
export interface IAttachmentItem {
  id: number;
  fileName: string;
  file: File;
  typeId: number;
}

export enum CandidateMode {
  Add = 1,
  Edit = 2,
}
//#endregion Core
